import axios from './_nestAxios'

export const obtenerxIdProductoPresentacionOrigenAsIdPromocion = idProductoPresentacionOrigen =>
  axios.get(`/promociones/producto-presentacion-origen/${idProductoPresentacionOrigen}`)

export const obtenerxIdsProductoPresentacionOrigenAsInfoPromocion = ids =>
  axios.get('/promociones/info-promocion', { params: { ids } })

export const obtenerxIdAsEdicion = id => axios.get(`/promociones/${id}`)

export const nuevo = data => axios.post('/promociones', data)

export const actualizarxId = (id, data) => axios.put(`/promociones/${id}`, data)

export const eliminarxId = id => axios.delete(`/promociones/${id}`)
